import { Input } from "@/src/components/universalInput";
import { Discharge, exitModes, FolderItem, Patient } from "@/src/data/allTypes";
import React from "react";
import { DocumentsCompartment } from "../documents/documentsCompartment";
import { AppointmentsHistory } from "../patients/appointmentsHistory";

export function DischargeForm({
  patient,
  parent,
  discharge,
  onChange,
}: {
  patient: Patient;
  parent: FolderItem;
  discharge: Discharge;
  onChange?: (newValue: Discharge) => void;
}) {
  const [current, setCurrent] = React.useState(discharge);
  function onLocalChange(newValue: Discharge) {
    setCurrent(newValue);
    onChange?.(newValue);
  }
  return (
    <div className="c1 gap10">
      <Input
        type="chips"
        name={""}
        value={current.dischargeType}
        options={[
          {
            value: "immediate",
            label: "Sortie immédiate",
          },
          {
            value: "planned",
            label: "Sortie future",
          },
        ]}
        onChange={(newValue) => {
          onLocalChange({ ...current, dischargeType: newValue });
        }}
      ></Input>
      {current.dischargeType == "planned" && (
        <Input
          type="date"
          name={"Date de sortie prévue"}
          value={current.exitDate}
          onChange={(newValue) => {
            onLocalChange({ ...current, exitDate: newValue });
          }}
        ></Input>
      )}
      <Input
        type="select"
        name={"Mode de sortie"}
        value={current.exitMode}
        options={Object.values(exitModes).map((value) => ({
          value: value.id,
          label: value.name,
        }))}
        onChange={(newValue) => {
          onLocalChange({ ...current, exitMode: newValue });
        }}
      ></Input>
      <Input
        type="textarea"
        name={"Notes"}
        value={current.notes}
        onChange={(newValue) => {
          onLocalChange({ ...current, notes: newValue });
        }}
      ></Input>

      <div></div>
      <DocumentsCompartment
        patient={patient}
        parent={parent}
        color="green"
      ></DocumentsCompartment>
      <div></div>

      <AppointmentsHistory
        patient={patient}
        title="Rendez-vous"
        types={null}
        showPastAppointments={false}
      ></AppointmentsHistory>
    </div>
  );
}
